import { useEffect, useState } from 'react'
import toPairs from 'lodash-es/toPairs'

import { EMPTY_OBJECT } from '../../../../constants/common'

export function useEmailCreationFormFields(initialFieldProps) {
  const [fieldsProps, setFieldsProps] = useState(initialFieldProps)
  const [fieldsInitialValues, setFieldsInitialValues] = useState(EMPTY_OBJECT)

  useEffect(() => {
    toPairs(initialFieldProps).forEach(([fieldName, fieldProps]) => {
      if (fieldProps.loadInitialValue) {
        setFieldsProps(currFieldsProps => ({
          ...currFieldsProps,
          [fieldName]: { ...fieldProps, isLoading: true },
        }))

        fieldProps
          .loadInitialValue()
          .then(data =>
            setFieldsInitialValues(currFieldsInitialValues => ({
              ...currFieldsInitialValues,
              [fieldName]: data,
            }))
          )
          // A failed load keeps the field initial value; do not leak an unhandled rejection.
          .catch(() => null)
          .finally(() =>
            setFieldsProps(currFieldsProps => ({
              ...currFieldsProps,
              [fieldName]: { ...fieldProps, isLoading: false },
            }))
          )
      } else {
        setFieldsProps(currFieldsProps => ({
          ...currFieldsProps,
          [fieldName]: fieldProps,
        }))
      }
    })
  }, [initialFieldProps])

  return [fieldsProps, fieldsInitialValues]
}
